import { useEffect, useRef, useState } from "react"

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center min-w-[64px] md:min-w-[84px] rounded-2xl bg-white/10 border border-white/10 px-3 py-3">
    <span className="text-3xl md:text-5xl font-extrabold tabular-nums text-white">
      {String(value).padStart(2, "0")}
    </span>
    <span className="mt-1 text-[10px] md:text-xs uppercase tracking-widest text-[#60A5FA]">
      {label}
    </span>
  </div>
)

/*
  Time left until the event goes live.

  Counted on the server's clock, not the device's: `serverTime` is when the API
  answered and `fetchedAt` is when this device received it, so their difference
  corrects a phone whose clock is wrong. `onDone` fires once, at zero, so the
  page can fetch the now-live event.
*/
const Countdown = ({ startsAt, serverTime, fetchedAt, onDone }) => {
  const offset = new Date(serverTime).getTime() - fetchedAt
  const target = new Date(startsAt).getTime()
  const [now, setNow] = useState(() => Date.now() + offset)
  const doneRef = useRef(false)

  useEffect(() => {
    const intervalId = setInterval(() => setNow(Date.now() + offset), SECOND)
    return () => clearInterval(intervalId)
  }, [offset])

  const remaining = Math.max(0, target - now)

  useEffect(() => {
    if (remaining > 0 || doneRef.current) return
    doneRef.current = true
    onDone?.()
  }, [remaining, onDone])

  return (
    <div className="flex justify-center gap-2 md:gap-4" role="timer">
      <Unit label="Days" value={Math.floor(remaining / DAY)} />
      <Unit label="Hours" value={Math.floor((remaining % DAY) / HOUR)} />
      <Unit label="Minutes" value={Math.floor((remaining % HOUR) / MINUTE)} />
      <Unit label="Seconds" value={Math.floor((remaining % MINUTE) / SECOND)} />
    </div>
  )
}

export default Countdown
